import { useQueryParamHelper } from '@shared/core/queryString';
import { HotelSearchContextParams, HotelSearchMapLayout, HotelSearchSource } from '@shared/constants/accommodations';

type UseHotelSearchConfigReturn = Readonly<{
  source: HotelSearchSource;
  layout: HotelSearchMapLayout;
}>;

export const useHotelSearchConfig = (): UseHotelSearchConfigReturn => {
  const queryParamHelper = useQueryParamHelper();

  const source = (queryParamHelper.getValueString(HotelSearchContextParams.source) as HotelSearchSource | null) ?? HotelSearchSource.OTA;
  const layout = (queryParamHelper.getValueString(HotelSearchContextParams.layout) as HotelSearchMapLayout | null) ?? HotelSearchMapLayout.COMPACT;

  return { source, layout };
};
